<!-- Endpoint section -->
<div class="container-fluid option-bar">

  <div class="row mt-2" *ngIf="type === TYPE_ENDPOINT">
    <div class="col-6">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
    <div class="col-6 setting-option" *ngIf="isListPage">
      <button class="btn relay-btn relay-createbtn create-New" [routerLink]="['new']" ngbTooltip="Create new endpoint" placement="left">{{'New'}}</button>
    </div>
    <div class="d-flex col-6 justify-content-end ngSelectOption " *ngIf="isSettingEnabled">
      <span class="webtool-text p-2" *ngIf="webConfigtool?.WEB_AUTOMATION_TOOL === 'PLAYWRIGHT'"> {{webConfigtool?.WEB_AUTOMATION_TOOL}}  </span>
      <span [appPermission]="[ADMIN, DEVELOPER, TESTER]" *ngIf="(details.certified || (details.showBrowserOptions && !details.subFlow))">
        <ng-select id="browser-type"  searchable="true" class="mb-2 ml-2"
        [items]="browserTypes"
        [(ngModel)]="selectedBrowser" placeholder="Select Browser" dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item}}" class="text-truncate">{{item}}</div>
          </ng-template></ng-select>
      </span>
      <span [appPermission]="[ADMIN, DEVELOPER, TESTER]" >
        <ng-select id="environment-list"  searchable="true" class="mb-2 ml-2" style="width: 200px;"
        *ngIf="details.environmentSpecific && !details.subFlow" [items]="activeEnv" [bindLabel]="'name'"
        [(ngModel)]="selectedEnv" placeholder="Select env" dropdownPosition="bottom" >
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
          </ng-template>
        </ng-select>
      </span>

      <!-- Menu section -->
      <ul class="d-flex justify-content-end align-items-top listValue">
        <li [appPermission]="[ADMIN, DEVELOPER, TESTER]" *ngIf="!details.subFlow">
          <a ngbTooltip="Execute this endpoint" placement="left" (click)="executeEndpoint(selectedOS,selectedBrowser,selectedEnv)" [ngClass]="{'anchor-tag-disabled': (details.environmentSpecific && selectedEnv === null)}">
            <i class="far fa-play-circle clickable"></i>
          </a>
        </li>

        <li [appPermission]="[ADMIN, DEVELOPER]" placement="left" ngbTooltip="Edit Endpoint">
          <a *ngIf="!details.webEndPoint && !details.mobileEndPoint" [routerLink]="['/endpoint', details.id, 'edit']">
            <i class="fas fa-edit clickable"></i>
          </a>
          <a *ngIf="!details.mobileEndPoint && details.webEndPoint && !details.subFlow" [routerLink]="['/endpoint', details.id, 'web-update']">
            <i class="fas fa-edit clickable"></i>
          </a>
          <a *ngIf="!details.mobileEndPoint && details.webEndPoint && details.subFlow" [routerLink]="['/endpoint', details.id, 'subflow-update']">
            <i class="fas fa-edit clickable"></i>
          </a>
          <a *ngIf="details.mobileEndPoint" [routerLink]="['/endpoint', details.id, 'mobile-instructions-update']">
            <i class="fas fa-edit clickable"></i>
          </a>
        </li>

        <li [appPermission]="[ADMIN, DEVELOPER]" ngbTooltip="Clone Endpoint" placement="left">
          <a>
            <i class="far fa-clone clickable" (click)="clone()"></i>
          </a>
        </li>

        <!-- Delete -->
        <li [appPermission]="[ADMIN, DEVELOPER]" ngbTooltip="Delete this Endpoint" placement="left">
          <a class="clickable">
            <i class="far fa-trash-alt text-danger" (click)="delete()"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="col setting-option pt-1" *ngIf="createNewEndpointForm">
      <ul class="list-inline" *ngIf="!createNewEndpointForm.value.id">
        <li>
          <a [routerLink]="['/endpoint/new/import-curl']" title="Import  Command">
            <img src="/assets/images/icons/import@2x.png" height="22" *ngIf="createNewEndpointForm.value.endPointType === 'REST' || createNewEndpointForm.value.endPointType.name === 'REST' || createNewEndpointForm.value.endPointType.name === 'SOAP' || createNewEndpointForm.value.endPointType === 'SOAP'">
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Testcase section starts here -->
  <div class="row mt-2" *ngIf="type === TYPE_TESTCASE">
    <div class="col-6">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
    <div class="col setting-option" *ngIf="isListPage">
      <button class="btn relay-btn relay-createbtn create-New" [routerLink]="['new']" ngbTooltip="Create new testcase" placement="left">{{'New'}}</button>
    </div>
    <div class="d-flex col-6 justify-content-end ngSelectOption" *ngIf="isSettingEnabled">
      <span [appPermission]="[ADMIN,DEVELOPER,TESTER]" *ngIf="details.project.projectConfig.allowTestDataSelectionInTestCaseExecution	&& (details.desktopTestCase || details.mobileTestCase)">
        <form [formGroup]="testDataForm">
          <div class="form-group mb-0">
            <ng-select [items]="testDataList" [clearSearchOnAdd]="true" style="width: 200px;"
              [closeOnSelect]="false" [multiple]="true" placeholder="Select Test Data"
              clearAllText="Clear" formControlName="selectedTestDataList" bindLabel="name">
              <ng-template ng-header-tmp>
                <div class="row ml-2">
                  <input type="checkbox" [checked]="getCheckedValue(testDataList, testDataForm.value.selectedTestDataList)" (change)="setSelectAll($event)"/> <span class="ml-1">All</span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div class="row ml-1">
                  <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"    [ngModelOptions]="{standalone: true}"/>
                  <span class="ml-1">{{item.name}}</span>
              </div>
              </ng-template>
              <ng-template ng-multi-label-tmp let-items="items">
                <div class="ng-value" *ngFor="let item of items | slice:0:1">
                  {{item.name}}
                </div>
                <div class="ng-value" *ngIf="items.length > 1">
                  <span class="ng-value-label">{{items.length - 1}} more...</span>
                </div>
              </ng-template>
            </ng-select>
            <br>
          </div>
        </form>
      </span>
      <span class="webtool-text p-2" *ngIf="webConfigtool?.WEB_AUTOMATION_TOOL === 'PLAYWRIGHT'"> {{webConfigtool?.WEB_AUTOMATION_TOOL}}  </span>
      <!-- OS type section -->
      <span>
        <ng-select *ngIf="details.showBrowserOptions"  searchable="true"
        class="mb-2 ml-2" [items]="OsTypes" [(ngModel)]="selectedOS" placeholder="Select OS" dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item}}" class="text-truncate">{{item}}</div>
          </ng-template>
      </ng-select>
      </span>

      <!-- Browser type section -->
      <span [appPermission]="[ADMIN,DEVELOPER,TESTER]" *ngIf="details.showBrowserOptions">
        <ng-select id="browser-type"  searchable="true" class="mb-2 ml-2"
        [items]="browserTypes"
        [(ngModel)]="selectedBrowser" placeholder="Select Browser" dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item}}" class="text-truncate">{{item}}</div>
          </ng-template>
        </ng-select>
      </span>

      <!-- Environment section -->
      <span [appPermission]="[ADMIN,DEVELOPER,TESTER]">
        <ng-select id="environment-list" (change)="changeEnv(selectedEnv)"  searchable="true" class="mb-2 ml-2"
         [items]="activeEnv" [bindLabel]="'name'" style="width: 200px;"
        [(ngModel)]="selectedEnv" placeholder="Select env" dropdownPosition="bottom" >
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item.name}}"  class="text-truncate">{{item.name}}</div>
          </ng-template>
        </ng-select>
      </span>

      <!-- Menu section -->
      <ul class="d-flex justify-content-end align-items-top listValue">
        <li [appPermission]="[ADMIN,DEVELOPER,TESTER]" ngbTooltip="Execute this testcase" placement="left">
          <a (click)="executeTestcase(selectedOS,selectedBrowser,selectedEnv, testDataForm.value.selectedTestDataList)" [ngClass]="{'anchor-tag-disabled': selectedEnv === null}">
            <!-- <img src="/assets/images/icons/execute.png" width="16"> -->
            <i class="far fa-play-circle clickable"></i>
          </a>

        </li>


        <li [appPermission]="[ADMIN, DEVELOPER]" placement="left" ngbTooltip="Import Testdata" *ngIf="isTestcaseTestdata && webConfigtool?.WEB_AUTOMATION_TOOL !== 'PLAYWRIGHT'">
          <a (click)="handleImportExport('import')" class="anchor-tag">
            <i class="fas fa-file-import clickable"></i>
          </a>
        </li>

        <li [appPermission]="[ADMIN, DEVELOPER]" placement="left" ngbTooltip="Export Testdata" *ngIf="isTestcaseTestdata && webConfigtool?.WEB_AUTOMATION_TOOL !== 'PLAYWRIGHT'">
          <a (click)="handleImportExport('export')" class="anchor-tag">
            <i class="fas fa-file-export clickable"></i>
          </a>
        </li>

        <!-- Edit -->
        <li [appPermission]="[ADMIN, DEVELOPER]" placement="left" ngbTooltip="Edit Testcase" *ngIf="!details.certificationInReview">
          <a [routerLink]="['/testcase', details.id, 'edit']" class="anchor-tag">
            <i class="far fa-edit clickable"></i>
          </a>
        </li>

        <!-- Clone -->
        <li [appPermission]="[ADMIN, DEVELOPER]" ngbTooltip="Clone Testcase" placement="left">
          <a>
            <i class="far fa-clone clickable" (click)="clone()"></i>
          </a>
        </li>

        <!-- Delete -->
        <li [appPermission]="[ADMIN, DEVELOPER]" ngbTooltip="Delete this testcase" placement="left">
          <a class="clickable">
            <i class="far fa-trash-alt text-danger" (click)="delete()"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Testsuite section starts here -->
  <div class="row mt-2" *ngIf="type === TYPE_TESTSUITE">
    <div class="col-6">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
    <div class="col setting-option" *ngIf="isListPage">
      <button class="btn relay-btn relay-createbtn create-New" [routerLink]="['new']" ngbTooltip="Create new testsuite" placement="left">{{'New'}}</button>
    </div>
    <div class="d-flex col-6 justify-content-end ngSelectOption" *ngIf="isSettingEnabled">
      <span class="webtool-text p-2" *ngIf="webConfigtool?.WEB_AUTOMATION_TOOL === 'PLAYWRIGHT'"> {{webConfigtool?.WEB_AUTOMATION_TOOL}}  </span>
      <!-- OS type section -->
      <span *ngIf="details.showBrowserOptions">
        <ng-select *ngIf="details.showBrowserOptions"  searchable="true"
        class="mb-2 ml-2" [items]="OsTypes" [(ngModel)]="selectedOS" placeholder="Select OS" dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item}}"  class="text-truncate">{{item}}</div>
          </ng-template>
      </ng-select>

      </span>

      <!-- Browser type section -->
      <span [appPermission]="[ADMIN,DEVELOPER,TESTER]" *ngIf="details.showBrowserOptions">
        <ng-select id="browser-type"  searchable="true"
        class="mb-2 ml-2" [items]="browserTypes" [(ngModel)]="selectedBrowser" placeholder="Select Browser" dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item}}"  class="text-truncate">{{item}}</div>
          </ng-template>
      </ng-select>

      </span>

      <!-- Environment section -->
      <span [appPermission]="[ADMIN,DEVELOPER,TESTER]">
        <ng-select id="environment-list"   searchable="true" class="mb-2 ml-2"
        [items]="activeEnv" [bindLabel]="'name'" style="width: 200px;"
        [(ngModel)]="selectedEnv" placeholder="Select env" dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item.name}}"  class="text-truncate">{{item.name}}</div>
          </ng-template>
      </ng-select>
      </span>

      <!-- Menu section -->
      <ul class="d-flex justify-content-end align-items-top listValue">
        <li [appPermission]="[ADMIN,DEVELOPER,TESTER]">
          <a ngbTooltip="Execute this Testsuite" placement="left" (click)="executeTestsuite(selectedOS,selectedBrowser,selectedEnv)" [ngClass]="{'anchor-tag-disabled': selectedEnv === null}">
            <!-- <img src="/assets/images/icons/execute.png" width="16"> -->
             <i class="far fa-play-circle clickable"></i>
          </a>
        </li>

        <!-- Edit -->
        <li [appPermission]="[ADMIN, DEVELOPER]" placement="left" ngbTooltip="Edit Testsuite">
          <a [routerLink]="['/testsuite', details.id, 'edit']" class="anchor-tag">
            <i class="far fa-edit clickable"></i>
          </a>
        </li>

        <!-- Clone -->
        <li [appPermission]="[ADMIN, DEVELOPER]" ngbTooltip="Clone Testsuite" placement="left" *ngIf="webConfigtool?.WEB_AUTOMATION_TOOL !== 'PLAYWRIGHT'">
          <a>
            <i class="far fa-clone clickable" (click)="clone()"></i>
          </a>
        </li>

        <!-- Delete -->
        <li [appPermission]="[ADMIN, DEVELOPER]" ngbTooltip="Delete this testsuite" placement="left">
          <a class="clickable">
            <i class="far fa-trash-alt text-danger" (click)="delete()"></i>
          </a>
        </li>

      </ul>

    </div>
  </div>

  <!-- mastersuite section starts here -->
  <div class="row mt-2" *ngIf="type === TYPE_MASTERSUITE">
    <div class="col-6">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
    <div class="col setting-option" *ngIf="isListPage">
      <button class="btn relay-btn relay-createbtn create-New" [routerLink]="['new']" ngbTooltip="Create new mastersuite" placement="left">{{'New'}}</button>
    </div>
    <div class="d-flex col-6 justify-content-end ngSelectOption" *ngIf="isSettingEnabled">
      <span class="webtool-text p-2" *ngIf="webConfigtool?.WEB_AUTOMATION_TOOL === 'PLAYWRIGHT'"> {{webConfigtool?.WEB_AUTOMATION_TOOL}}  </span>
      <!-- OS type section -->
      <span [appPermission]="[ADMIN, DEVELOPER, TESTER]" *ngIf="details.showBrowserOptions">
      <ng-select id="browser-type"  searchable="true"
      class="mb-2 ml-2" [items]="OsTypes" [(ngModel)]="selectedOS" placeholder="Select OS" dropdownPosition="bottom">
      <ng-template ng-option-tmp let-item="item">
        <div title="{{item}}"  class="text-truncate">{{item}}</div>
        </ng-template>
    </ng-select>
      </span>

      <!-- Browser type section -->
      <span [appPermission]="[ADMIN, DEVELOPER, TESTER]" *ngIf="details.showBrowserOptions">
        <ng-select id="browser-type"  searchable="true"
        class="mb-2 ml-2" [items]="browserTypes" [(ngModel)]="selectedBrowser" placeholder="Select Browser" dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item}}"  class="text-truncate">{{item}}</div>
          </ng-template>
      </ng-select>

      </span>

      <!-- Environment section -->
      <span [appPermission]="[ADMIN,DEVELOPER,TESTER]">
        <ng-select id="environment-list"   searchable="true" class="mb-2 ml-2" style="width: 200px;"
        [items]="activeEnv" [bindLabel]="'name'"
        [(ngModel)]="selectedEnv"  placeholder="Select env" dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
          <ng-option title="{{item.name}}">{{item.name}}</ng-option>
          </ng-template>
      </ng-select>

      </span>

      <!-- Menu section -->
      <ul class="d-flex justify-content-end align-items-top listValue">
        <!-- Execute -->
        <li [appPermission]="[ADMIN, DEVELOPER, TESTER]">
          <a ngbTooltip="Execute this mastersuite" placement="left" (click)="executeMasterSuite(selectedOS, selectedBrowser, selectedEnv)" [ngClass]="{'anchor-tag-disabled': selectedEnv === null}">
            <i class="far fa-play-circle clickable"></i>
          </a>
        </li>

        <!-- Edit -->
        <li [appPermission]="[ADMIN, DEVELOPER]" placement="left" ngbTooltip="Edit Mastersuite">
          <a [routerLink]="['/mastersuite', details.id, 'edit']" class="anchor-tag">
            <i class="far fa-edit clickable"></i>
          </a>
        </li>

        <!-- Clone -->
        <li [appPermission]="[ADMIN, DEVELOPER]" ngbTooltip="Clone mastersuite" placement="left" *ngIf="webConfigtool?.WEB_AUTOMATION_TOOL !== 'PLAYWRIGHT'">
          <a>
            <i class="far fa-clone clickable" (click)="clone()"></i>
          </a>
        </li>

        <!-- Delete -->
        <li [appPermission]="[ADMIN, DEVELOPER]" ngbTooltip="Delete this mastersuite" placement="left">
          <a class="clickable">
            <i class="far fa-trash-alt text-danger" (click)="delete()"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>


  <div class="row mt-2" *ngIf="type === TYPE_EXECUTION_HISTORY_TESTCASE">
    <div class="col">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
  </div>

  <div class="row mt-2" *ngIf="type === TYPE_EXECUTION_RESULTS_TESTCASE">
    <div class="col">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
  </div>

  <!-- User Section -->
  <div class="row mt-2" *ngIf="type === TYPE_USER">
    <div class="col">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
  </div>

  <!-- Gopher Section -->
  <div class="row mt-2" *ngIf="type === TYPE_GOPHER">
    <div class="col">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
  </div>
</div>